module.exports = __webpack_public_path__ + "static/media/4.a54e2aaf.png";